function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.9
}, /*#__PURE__*/React.createElement("path", {
  d: "M37.4849 1.83008V20.1158H35.4849V1.83008H37.4849Z",
  fill: "#323B4C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.4577 25.7312L61.3877 12.8012L59.9735 11.387L47.0435 24.317L48.4577 25.7312Z",
  fill: "#323B4C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.8015 61.3874L25.7314 48.4575L24.3172 47.0433L11.3873 59.9732L12.8015 61.3874Z",
  fill: "#323B4C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.7312 24.8168L12.8012 11.8869L11.387 13.3011L24.317 26.231L25.7312 24.8168Z",
  fill: "#323B4C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.82812 35.6568H20.1138V37.6568H1.82812V35.6568Z",
  fill: "#323B4C"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M65.6415 75.0728L56.2566 84.4578L38.327 37.4143L85.3705 55.3439L75.9855 64.7289L93.2793 82.0227L82.9354 92.3666L65.6415 75.0728ZM57.0258 80.8602L41.7855 40.8728L81.7729 56.1131L73.1571 64.7289L90.4509 82.0227L82.9354 89.5382L65.6415 72.2444L57.0258 80.8602Z",
  fill: "#323B4C"
}));

function SvgMandatoryTaskIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMandatoryTaskIcon);
export default __webpack_public_path__ + "static/media/MandatoryTaskIcon.8c193114542371debad8b6eeed9c260c.svg";
export { ForwardRef as ReactComponent };